import type { Shadows } from "@mui/material/styles";

/* ----------------------------- */
/* Light Theme Shadows */
/* ----------------------------- */

export const lightShadows: Shadows = [
  "none",
  "0px 1px 2px rgba(0,0,0,0.04)",
  "0px 2px 6px rgba(0,0,0,0.06)",
  "0px 4px 12px rgba(0,0,0,0.08)",
  "0px 6px 16px rgba(0,0,0,0.10)",
  "0px 8px 20px rgba(0,0,0,0.12)",
  "0px 10px 24px rgba(0,0,0,0.14)",
  "0px 12px 28px rgba(0,0,0,0.16)",
  "0px 14px 32px rgba(0,0,0,0.18)",
  "0px 16px 36px rgba(0,0,0,0.20)",
  "0px 18px 40px rgba(0,0,0,0.22)",
  "0px 20px 44px rgba(0,0,0,0.24)",
  "0px 22px 48px rgba(0,0,0,0.26)",
  "0px 24px 52px rgba(0,0,0,0.28)",
  "0px 26px 56px rgba(0,0,0,0.30)",
  "0px 28px 60px rgba(0,0,0,0.32)",
  "0px 30px 64px rgba(0,0,0,0.34)",
  "0px 32px 68px rgba(0,0,0,0.36)",
  "0px 34px 72px rgba(0,0,0,0.38)",
  "0px 36px 76px rgba(0,0,0,0.40)",
  "0px 38px 80px rgba(0,0,0,0.42)",
  "0px 40px 84px rgba(0,0,0,0.44)",
  "0px 42px 88px rgba(0,0,0,0.46)",
  "0px 44px 92px rgba(0,0,0,0.48)",
  "0px 46px 96px rgba(0,0,0,0.50)",
];

/* ----------------------------- */
/* Dark Theme Shadows */
/* ----------------------------- */

export const darkShadows: Shadows = [
  "none",
  "0px 1px 2px rgba(0,0,0,0.35)",
  "0px 2px 6px rgba(0,0,0,0.40)",
  "0px 4px 12px rgba(0,0,0,0.45)",
  "0px 6px 16px rgba(0,0,0,0.50)",
  "0px 8px 20px rgba(0,0,0,0.55)",
  "0px 10px 24px rgba(0,0,0,0.60)",
  "0px 12px 28px rgba(0,0,0,0.65)",
  "0px 14px 32px rgba(0,0,0,0.70)",
  "0px 16px 36px rgba(0,0,0,0.72)",
  "0px 18px 40px rgba(0,0,0,0.74)",
  "0px 20px 44px rgba(0,0,0,0.76)",
  "0px 22px 48px rgba(0,0,0,0.78)",
  "0px 24px 52px rgba(0,0,0,0.80)",
  "0px 26px 56px rgba(0,0,0,0.82)",
  "0px 28px 60px rgba(0,0,0,0.84)",
  "0px 30px 64px rgba(0,0,0,0.86)",
  "0px 32px 68px rgba(0,0,0,0.88)",
  "0px 34px 72px rgba(0,0,0,0.90)",
  "0px 36px 76px rgba(0,0,0,0.92)",
  "0px 38px 80px rgba(0,0,0,0.94)",
  "0px 40px 84px rgba(0,0,0,0.96)",
  "0px 42px 88px rgba(0,0,0,0.98)",
  "0px 44px 92px rgba(0,0,0,1)",
  "0px 46px 96px rgba(0,0,0,1)",
];
